import { Injectable } from '@angular/core';
import { TdDialogService } from '@covalent/core';

import { DialogRef, PromptConfig } from './common';
import { PromptDialogComponent } from './prompt-dialog.component';

@Injectable()
export class DialogService extends TdDialogService {
  openPromptDialog(config: PromptConfig): DialogRef<PromptDialogComponent> {
    return this.open(PromptDialogComponent, {
      disableClose: true,
      closeOnNavigation: false,
      data: {
        maxInputLength: config.maxLength,
        promptConfig: config
      }
    });
  }
}

export {
  TdAlertDialogComponent as AlertDialogComponent,
  TdConfirmDialogComponent as ConfirmDialogComponent,
  IAlertConfig as AlertConfig,
  IConfirmConfig as ConfirmConfig
} from '@covalent/core';
